import { combineReducers } from 'redux';
import { initialDepartments } from '../../settings/reducers/departments';
import * as constants from '../actions/constants';
import { WizardActions } from '../actions/wizardActions';
import { IWizardDirectCost, IWizardProject, IWizardProjectActivity } from '../types/wizardData';
import { IWizardPassThroughCost } from './../types/wizardData';

export const initialwizardProjectPhase = {
  id: '',
  name: '',
  active: false,
  start_date: '',
  end_date: '',
  finished: false,
  color: '#BEC8C3'
}

export const initialWizardAct: IWizardProjectActivity = {
  id: '',
  name: '',
  phase: initialwizardProjectPhase,
  department: initialDepartments[0],
  start_date: null,
  end_date: null,
  current_hours: 0,
  total_hours: 0,
  status: 'upcoming'
}

export const initialWizardDirectCost: IWizardDirectCost = {
  id: '',
  key: '',
  offer_position: '',
  phase: initialwizardProjectPhase,
  department: initialDepartments[0],
  unit: '',
  quantity: 0,
  unit_hours: 0,
  unit_price: 0,
  start_date: null,
  end_date: null
}

export const initialWizardPassThroughCost: IWizardPassThroughCost = {
  id: '',
  offer_position: '',
  phases: [initialwizardProjectPhase],
  supplier: '',
  unit: '',
  quantity: 0,
  unit_price: 0,
  start_date: null,
  end_date: null
}

export const initialData: IWizardProject = {
  name: '',
  customer: '',
  category: '',
  type: '',
  permissions: '',
  employees: [],
  start_date: null,
  end_date: null,
  phases: [],
  health: '',
  activities: [],
  active: true,
  color: '',
  input_option: ''
}

const wizardStep = (state = '', action: WizardActions) => {
  switch(action.type) {
    case constants.SET_WIZARD_STEP:
      return action.step

    default:
      return state
  }
}

const projectWizardData = (state: IWizardProject = initialData, action: WizardActions) => {
  switch(action.type) {
    case constants.SET_PROJECT_WIZARD_DATA:
      return action.data

    case constants.SET_WIZARD_STEP:
      if (action.step === '') {
        return initialData
      }
      return state

    default:
      return state
  }
}

const wizardFinishedSteps = (state: number[] = [], action: WizardActions) => {
  switch(action.type) {
    case constants.SET_WIZARD_FINISHED_STEPS:
      return action.steps

    default:
      return state
  }
}

export interface WizardState {
  wizardStep: string
  projectWizardData: IWizardProject
  wizardFinishedSteps: number[]
}

const wizardApp = combineReducers<WizardState>({
  wizardStep,
  projectWizardData,
  wizardFinishedSteps
})

export default wizardApp
